export default {"src":"/_next/static/media/eth_logo_ic.7f6b18c6.svg","height":24,"width":24};